module.exports = __webpack_public_path__ + "img/Methylenedioxyme-thamphetamine (MDMA).46ea064c.png";